import $ from 'jquery';
export function validate_card_info(t)
{
    var card_expirationDate = document.getElementById("card_expirationDate_input").value;

    var api_link = "/api/HData/validate_creditcard_info/data";
    var parameters = {
        card_number: t.state.cardNumber,
        card_expiration_year: card_expirationDate.split('/')[1],
        card_expiration_month: card_expirationDate.split('/')[0],
        card_verfication_no: t.state.verficationNumber,
        card_type: t.state.cardType,
        card_first_name: t.state.firstName,
        card_last_name: t.state.lastName,
        card_address: t.state.cardAddress,
        card_country:"US",
        card_city: t.state.cardCity,
        card_state: t.state.cardState,
        card_ZIP_code: t.state.cardZIPCode
    };

     $.ajax({
        type: "POST",
        url: api_link,
        data: JSON.stringify( parameters),
        async: false,
        contentType: 'application/json',
        dataType: "text",
        success: function (response)
        {validate_card_info_success(t, response); },
        error: validate_card_info_error
    });
}
function validate_card_info_success(t, response)
{
    if (response !== "true")
    {
        t.showToast(response, "error");
    }
    else
    {
        var card_expirationDate = document.getElementById("card_expirationDate_input").value;
        var card_info = {
            card_number: t.state.cardNumber,
            card_expiration_year: card_expirationDate.split('/')[1],
            card_expiration_month: card_expirationDate.split('/')[0],
            card_verfication_no: t.state.verficationNumber,
            card_type: t.state.cardType,
            card_first_name: t.state.firstName,
            card_last_name: t.state.lastName,
            card_address: t.state.cardAddress,
            card_country: "US",
            card_city: t.state.cardCity,
            card_state: t.state.cardState,
            card_ZIP_code: t.state.cardZIPCode

        };
        t.props.payByCreditCard(card_info);
    }
}
function validate_card_info_error(ex)
{
    debugger

}